export default {
    instructionCenter: {
        title: 'AI 指示ライブラリ',
        searchPlaceholder: '指示を検索...',
        gridView: 'グリッド表示',
        listView: 'リスト表示',
        createInstruction: '指示を作成',
        noInstructions: '指示がありません',
        noInstructionsDesc: '「指示を作成」ボタンをクリックして最初の指示を追加してください',
        loading: '読み込み中',
        loadMore: 'もっと見る',
        preview: 'プレビュー',
        edit: '編集',
        delete: '削除',
        cancel: 'キャンセル',
        save: '保存',
        saving: '保存中',
        moreActions: 'その他の操作',
        editInstruction: '指示を編集',
        addFavorite: 'お気に入りに追加',
        removeFavorite: 'お気に入りから削除',
        noResults: '指示が見つかりません',

        // Select Dialog
        selectDialog: {
            title: 'ライブラリから選択',
            forSection: 'セクション用',
        },

        // Technology Area
        technologyArea: {
            general: '一般',
            electrical: '電気',
            mechanical: '機械',
            chemical: '化学',
            software: 'ソフトウェア',
        },

        // Section
        section: {
            title: 'タイトル',
            background: '背景',
            summary: '要約',
            briefFigures: '図面の簡単な説明',
            claims: '請求項',
            abstract: '要約',
            detailed: '詳細な説明',
            detailedPlan: '詳細な説明計画',
            repeatClaims: '請求項の繰り返し',
            custom: 'カスタム',
        },

        // Filter
        filter: {
            title: 'フィルター',
            region: '地域',
            type: 'タイプ',
            from: 'ソース',
            myInstructions: 'マイ指示',
            library: 'ライブラリ',
            clear: '{count} 件のフィルターをクリア',
        },

        // Tabs
        tabs: {
            all: 'すべて',
            title: 'タイトル',
            abstract: '要約',
            background: '背景',
            summary: '発明の内容',
            claims: '請求の範囲',
            detailedDescription: '詳細な説明',
            officeActionResponse: 'Office Action Response',
            myInstructions: 'マイ指示',
            favorites: 'お気に入り',
        },

        // Pills
        pills: {
            all: 'すべての指示',
            my: 'マイ指示',
            official: '公式指示',
        },

        // Sections
        sections: {
            title: 'タイトル',
            abstract: '要約',
            background: '背景技術',
            summary: '発明の内容',
            briefFigures: '図面の簡単な説明',
            claims: '請求の範囲',
            detailed: '詳細な説明',
            custom: 'カスタム',
        },

        // Instruction Types
        instructionTypes: {
            patentApplication: '特許出願',
            inventionDisclosure: '発明開示',
            officeActionResponse: '拒絶理由通知への応答',
        },

        // Sources
        sources: {
            system: 'システム',
            custom: 'カスタム',
            library: 'ライブラリ',
        },

        // Dialog
        dialog: {
            name: '指示名',
            namePlaceholder: '指示名を入力してください',
            instructionType: '指示タイプ',
            templateSection: 'テンプレートセクション',
            selectSection: 'テンプレートセクションを選択',
            description: '説明',
            descriptionPlaceholder: '説明を入力してください（任意）',
            descriptionHint: 'この指示の目的と特徴を簡単に説明してください',
            content: 'AI 指示内容',
            contentPlaceholder: 'AI にコンテンツの生成方法を指示する内容を入力してください...',
            contentHint: 'AI がコンテンツを処理および生成する方法について、スタイル、形式、重点などを詳しく説明してください',
            advancedSettings: '詳細設定',
            region: '地域',
            technologyArea: '技術分野',
            optional: '任意',
            quickSettings: 'クイック設定',
            requiredFieldsHint: '* は必須項目を示します',
            fillBasicInfo: '基本情報を入力して新しい指示を作成',
            updateHint: '指示情報を更新',
            viewOnlyHint: 'システム指示の詳細を表示（読み取り専用モード）',
            unsavedChangesTitle: '未保存の変更',
            unsavedChangesMessage: '未保存の変更があります。閉じてもよろしいですか？変更内容は失われます。',
            discardChanges: '変更を破棄',
            continueEditing: '編集を続ける',
            systemReadOnlyHint: 'システム指示は読み取り専用で、編集できません',
            close: '閉じる',

            // Level selection (Super Admin only)
            level: '可視性',
            adminOnly: '管理者のみ',
            systemLevel: 'システムレベル',
            userLevel: 'ユーザーレベル',
        },

        // Messages
        messages: {
            saveFailed: '保存に失敗しました',
            fetchListFailed: '指示リストの取得に失敗しました',
            fetchDetailFailed: '指示の詳細取得に失敗しました',
            createSuccess: '作成に成功しました',
            createFailed: '作成に失敗しました',
            updateSuccess: '更新に成功しました',
            updateFailed: '更新に失敗しました',
            deleteSuccess: '削除に成功しました',
            deleteFailed: '削除に失敗しました',
            addFavoriteSuccess: 'お気に入りに追加しました',
            removeFavoriteSuccess: 'お気に入りから削除しました',
            favoriteOperationFailed: 'お気に入り操作に失敗しました',
        },
    },
};
